module.exports = __webpack_public_path__ + "img/23.c21b76ef.png";